module.exports = __webpack_public_path__ + "img/space_dust_poster.4e79cca7.png";